import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { DynamicLegalPage } from "@/components/pages/DynamicLegalPage";

export const Route = createFileRoute("/en/terms")({
  head: () =>
    buildHead({
      lang: "en",
      page: "home",
      title: "General terms of sale · 2AM Hospitality",
      description:
        "General terms of sale applicable to the services of 2AM Hospitality (VAT BE 0786 281 406).",
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "en") i18n.changeLanguage("en");
    }, []);
    if (i18n.language !== "en") i18n.changeLanguage("en");
    return <DynamicLegalPage slug="cgv" />;
  },
});
